import { Box, Collapse, Stack, Typography } from "@mui/material";
import { useState } from "react";
import ExpandCollapseButton from "@entrilia/shared/components/ExpandCollapseButton";
import CollapseIcon from "@entrilia/shared/icons/CollapseIcon";
import ExpandIcon from "@entrilia/shared/icons/ExpandIcon";

interface Props {
  skills: string[];
}

const SkillsSection = ({ skills }: Props) => {
  const [open, setOpen] = useState(true);

  return (
    <Box>
      <Stack direction="row" sx={{ alignItems: "center", gap: 0.5 }}>
        <ExpandCollapseButton
          expanded={open}
          onToggle={() => setOpen((v) => !v)}
          ExpandIcon={ExpandIcon}
          CollapseIcon={CollapseIcon}
        />
        <Typography>Skills ({skills.length} used)</Typography>
      </Stack>
      <Collapse in={open}>
        <Box sx={{ mt: 0.5, pl: 1.5 }}>
          {skills.map((name) => (
            <Stack key={name} direction="row" spacing={1} sx={{ alignItems: "baseline", py: 0.25 }}>
              <Typography variant="caption" sx={{ color: "success.main", width: 12 }}>
                {"✓"}
              </Typography>
              <Typography variant="caption" sx={{ fontWeight: "medium" }}>
                {name}
              </Typography>
            </Stack>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
};

export default SkillsSection;
